import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import React, { MutableRefObject } from "react";
import { FilterOption } from "../FilterPopover.types.ts";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { TextFieldWrapper } from "../FilterPopover.tsx";

export interface NumberIntervalValue {
    from: number | undefined;
    to: number | undefined;
}

export interface NumberFieldSubMenuProps {
    selectedOption?: FilterOption;
    onChange: (value: NumberIntervalValue) => void;
    onLeftArrowClick?: () => void;
    submenuInputRef?: MutableRefObject<HTMLTextAreaElement | undefined>;
    onApply?: (value: NumberIntervalValue) => void;
}

function NumberFieldSubMenu(props: NumberFieldSubMenuProps) {
    const { onChange, onLeftArrowClick, submenuInputRef, onApply } = props;
    const { translateString } = useTranslation();

    const value =
        typeof props.selectedOption?.value === "string" && props.selectedOption.value
            ? JSON.parse(props.selectedOption.value)
            : ((props.selectedOption?.value || { from: undefined, to: undefined }) as NumberIntervalValue);

    const onIntervalChange = (from: number | undefined, to: number | undefined) => {
        onChange({ from: from, to: to });
    };

    return (
        <TextFieldWrapper>
            <DotLegalTextField
                label={translateString("from")}
                value={value.from?.toString() ?? null}
                debounce={false}
                onlyNumber={"decimal"}
                onChange={(from) => onIntervalChange(from ? parseFloat(from) : undefined, value.to)}
                inputRef={submenuInputRef}
                onEnterPressed={() => onApply?.(value)}
                noMargin
            />
            <DotLegalTextField
                label={translateString("to")}
                value={value.to?.toString() ?? null}
                debounce={false}
                onlyNumber={"decimal"}
                onChange={(to) => onIntervalChange(value.from, to ? parseFloat(to) : undefined)}
                onEnterPressed={() => onApply?.(value)}
                noMargin
            />
        </TextFieldWrapper>
    );
}

export default NumberFieldSubMenu;
